import { render, staticRenderFns } from "./BeautyExtentionDataSheet.vue?vue&type=template&id=21947ae3&scoped=true"
import script from "./BeautyExtentionDataSheet.vue?vue&type=script&lang=js"
export * from "./BeautyExtentionDataSheet.vue?vue&type=script&lang=js"
import style0 from "./BeautyExtentionDataSheet.vue?vue&type=style&index=0&id=21947ae3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21947ae3",
  null
  
)

export default component.exports